import { observer } from 'mobx-react-lite';

import { pushNotifications } from '@gem/call/Removable/packages/permissions/permissions';

import { useCallPushNotificationPresenter } from './CallPushNotification.presenter';

interface ICallPushNotificationProps {
  redirectRoutePath?: string;
}

export const CallPushNotification = observer<ICallPushNotificationProps>((props) => {
  const presenter = useCallPushNotificationPresenter(props.redirectRoutePath);
  presenter.notifications.forEach((item) => {
    if (pushNotifications.getCurrentPermission() === 'granted') {
      const notification = new Notification(item.title, {
        body: item.body,
        icon: item.icon,
      });
      notification.onclick = item.onClick;
      presenter.onShowNotification(item.id);
    }
  });

  return null;
});
